module.exports = __webpack_public_path__ + "img/void_status.7baae083.svg";